<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";

export default {
  name: "App",
  data() {
    return {
      jsApiList: [
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "onMenuShareTimeline",
        "onMenuShareAppMessage"
      ]
      // shareLink: window.location.href.split("#")[0] + "?isShare=true",
      // title: "中国医师协会妇产科医师分会母胎医学专业委员会",
      // desc: document.title,
      // imgUrl: "https://yunejia.gzmoninet.com/wechat-images/share-pic.png"
    };
  },
  /**
   * 获取当前code，请求access_token
   */
  async created() {
    const that = this;
    // that.setShareFriends();
    // that.setShareTimeLine();
  },
  /**
   * 申请config
   */
  async mounted() {
    const that = this;
    const href = window.location.href.split("#")[0];
    const url = "/publicAccount/signature";
    const data = { url: href };
    let res = await that.http.post(url, data);
    console.log(res);
    if (res.code == 0) {
      let params = {
        debug: false,
        appId: res.data.appid,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        timestamp: res.data.timestamp,
        jsApiList: that.jsApiList
      };
      wx.config(params);
    } else {
      console.log(res);
    }
  },

  methods: {
    // /**
    //  * 设置分享给朋友
    //  */
    // setShareFriends() {
    //   const that = this;
    //   wx.ready(function() {
    //     //需在用户可能点击分享按钮前就先调用
    //     if (wx.updateAppMessageShareData) {
    //       wx.updateAppMessageShareData({
    //         title: that.title,
    //         desc: that.desc,
    //         link: that.shareLink,
    //         imgUrl: that.imgUrl,
    //         success: function() {
    //           // 设置成功
    //           console.log("share friends success");
    //         }
    //       });
    //     } else if (wx.onMenuShareAppMessage) {
    //       wx.onMenuShareAppMessage({
    //         title: that.title,
    //         desc: that.desc,
    //         link: that.shareLink,
    //         imgUrl: that.imgUrl,
    //         success: function() {
    //           // 设置成功
    //           console.log("success");
    //         }
    //       });
    //     }
    //   });
    // },
    // /**
    //  * 设置分享到朋友圈
    //  */
    // setShareTimeLine() {
    //   const that = this;
    //   wx.ready(function() {
    //     //需在用户可能点击分享按钮前就先调用
    //     if (wx.updateTimelineShareData) {
    //       wx.updateTimelineShareData({
    //         title: that.title,
    //         link: that.shareLink,
    //         imgUrl: that.imgUrl,
    //         success: function() {
    //           // 设置成功
    //           console.log("share timeLine success");
    //         }
    //       });
    //     } else if (wx.onMenuShareTimeline) {
    //       wx.onMenuShareTimeline({
    //         title: that.title,
    //         link: that.shareLink,
    //         imgUrl: that.imgUrl,
    //         success: function() {
    //           // 设置成功
    //           console.log("share timeLine success");
    //         }
    //       });
    //     }
    //   });
    // }
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  /* padding: 10px; */
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  height: 100%;
}
html,body{
  height: 100%;
  /* background: #f0f3fa; */
}

</style>



// WEBPACK FOOTER //
// src/App.vue